import React, { Component } from 'react';
import Container from '../../components/Container';
import Heading from '../../components/Heading';
import Form from './components/Form';
import Table from './components/Table';
import API from '../../services/API';
import { handleFieldChange } from "../../Utils";

class PayoutCountryFactor extends Component {
    constructor() {
        super();

        this.state = {
            affidValues: [],
            report: [],
            sortParam: null,
            sortOrder: 1,
            isLoading: false
        };

        this.handleFieldChange = handleFieldChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    componentDidMount() {
        API.PayoutCountryFactor.getAffid().then(affids => {
            this.setState({ affidValues: affids })
        });
    }

    componentWillUpdate(nextProps, nextState) {
        const { report, sortParam, sortOrder } = nextState;

        if(this.state.sortParam != sortParam || this.state.sortOrder != sortOrder) {
            this.sortReport(report, sortParam, sortOrder);

            this.setState({ report });
        }
    }

    sortReport(report, sortParam, sortOrder) {
        report.sort((objA, objB) => {
            if(objA[sortParam] > objB[sortParam]) return 1 * sortOrder;
            else if(objA[sortParam] < objB[sortParam]) return -1 * sortOrder;

            return 0;
        });
    }

    handleSubmit(filters, type) {
        this.setState({ isLoading: true });

        API.PayoutCountryFactor.get(filters, type).then(({ report }) => {
            this.setState({ report, isLoading: false })
        });
    }

    handleSort(param) {
        const { sortParam, sortOrder } = this.state;

        if(sortParam === null) this.setState({ sortParam: param });
        else if(param === sortParam) this.setState({ sortOrder: sortOrder * -1 });
        else this.setState({ sortParam: param, sortOrder: 1 });
    }

    getTable() {
        const { report, reportTotal } = this.state;

        return report.length ?
            <Table report={report} total={reportTotal} onSortChange={this.handleSort} /> :
            <p>No Data</p>
    }

    render() {
        const { isLoading, affidValues } = this.state;

        return (
            <Container loading={isLoading}>
                <Heading title="Payout Country Factor"/>
                <Form onSubmit={this.handleSubmit} affidValues={affidValues} />

                {this.getTable()}

            </Container>
        );
    }
}

export default PayoutCountryFactor;



// WEBPACK FOOTER //
// ./src/scenes/PayoutCountryFactor/index.js